import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {JsonSchemaEntityRef} from '@catcore/types/base';
import {eachObject, resolveEntityNameByResourceUri} from '@catcore/utils';
import {toJSONSchema} from '@catcore/utils/json-schema/entity-schema-to-json-schema';
import {Subject} from 'rxjs/Subject';
import {isNullOrUndefined} from 'util';

@Injectable()
export class EntitySchemaService {

  public BASE = '/api';
  private subject = new Subject();
  private data$ = this.subject.asObservable();
  private rawSchema: any;
  private schema: any;

  constructor(private http: HttpClient) {
  }

  refresh() {
    this.http
      .get(`${this.BASE}/_entity-schemas`)
      .subscribe((rawSchema: any) => {
        this.setSchema(rawSchema);
      });
  }

  setSchema(rawSchema: string) {
    this.rawSchema = rawSchema;
    this.schema = toJSONSchema(this.rawSchema);
    this.subject.next(this.schema);
  }

  getSchema() {
    return this.data$;
  }

  getRawSchema() {
      return this.rawSchema;
  }

  getForEntityName(entityName: string) {
    let entitySchema = null;
    if (Object.keys(this.schema.properties).includes(entityName)) {
      entitySchema = this.schema.properties[entityName];
    }
    return entitySchema;
  }

  getForResourceUri(resourceUri: string) {
    return this.getForEntityName(resolveEntityNameByResourceUri(resourceUri));
  }

  getRelatedEntitiesFor(entitySchemaType: string): JsonSchemaEntityRef[] {
    const references: JsonSchemaEntityRef[] = [];
    const alreadyUsedRef = [];
    if (!isNullOrUndefined(this.schema)) {
      eachObject(this.schema.properties, (schemaProperty, entityRef) => {
        eachObject(schemaProperty.properties, (entityProperty) => {
          let isUsable = entityProperty.resourceRef === entitySchemaType;
          isUsable = isUsable && !alreadyUsedRef.includes(entityRef);
          if (isUsable) {
            references.push({entityRef, value: schemaProperty});
            alreadyUsedRef.push(entityRef);
          }
        });
      });
    }
    return references;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/core/services/entity-schema.service.ts